import React from 'react';
import IconBase from './IconBase';

const PinIcon = props => {
    return (
        <IconBase {...props}>
            <path d="M16,10.7c-0.1,0-0.1,0-0.2,0V2.5h0.5c0.4,0,0.8-0.3,0.8-0.8c0-0.4-0.3-0.8-0.8-0.8H7.5C7.1,1,6.8,1.3,6.8,1.8c0,0.4,0.3,0.8,0.8,0.8H8v8.2c-1.1,0-2,0.9-2,2v1.5h5.2L12,24l0.8-9.8H18v-1.5C18,11.6,17.1,10.7,16,10.7z"/>
        </IconBase>
    )
}

export default PinIcon;